import OrderOptimizerPotentialDriversListRequest from "../../../api/raily/order-optimizer/potential-drivers-list/order-optimizer-potential-drivers-list.request";
import OrderOptimizerPotentialDriversListParams from "./order-optimizer-potential-drivers-list-params";

const create = (
  params: OrderOptimizerPotentialDriversListParams,
): OrderOptimizerPotentialDriversListRequest => {
  return {
    optimizationId: params.optimizationId,
    name: params.name,
  };
};

const orderOptimizerPotentialDriversListParamsFactory = {
  create,
};

export default orderOptimizerPotentialDriversListParamsFactory;
